import BankIcon from '@/shared/assets/document-icon.svg?react';
import { formatInvoiceDate, formatReceivedAmount } from '@/shared/lib';
import type { PaidInvoiceListItem } from '../model';

interface Props {
  invoices: PaidInvoiceListItem[];
  onInvoiceClick: (invoice: PaidInvoiceListItem) => void;
}

const formatAmount = (invoice: PaidInvoiceListItem) =>
  invoice.amount && invoice.currencyCode
    ? `${formatReceivedAmount(invoice.amount)} ${invoice.currencyCode}`
    : '-';

const PaidInvoicesListContent = ({ invoices, onInvoiceClick }: Props) => {
  return (
    <div className="h-full overflow-hidden py-[1.6rem] w-full bg-secondary-bg rounded-[1.6rem] flex flex-col flex-1">
      <div className="w-full py-[1.6rem] space-y-[0.8rem] h-full overflow-y-auto my-[-1.6rem]">
        {invoices.map(invoice => {
          const date = formatInvoiceDate(invoice.date);

          return (
            <div
              key={invoice.invoiceId}
              onClick={() => onInvoiceClick(invoice)}
              className="flex items-center gap-[2.4rem] px-[2.4rem] min-h-[5.6rem] hover:bg-stroke transition-colors cursor-pointer">
              <div className="flex-shrink-0">
                <BankIcon className="w-[2.4rem] h-[2.4rem] text-foreground" />
              </div>

              <div className="flex-1 flex flex-col gap-[0.4rem]">
                <div className="headline4 text-foreground">
                  {invoice.bankName}
                </div>
                {date && <div className="p5 text-muted-foreground">{date}</div>}
              </div>

              <div className="headline4 text-foreground">
                {formatAmount(invoice)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { PaidInvoicesListContent };
